export default __webpack_public_path__ + "static/SanFranciscoText-Medium-c41757ff1d915a002eaf156b7b214be7.woff2";